import * as React from 'react';
import classnames from 'classnames';
import { KeyboardEvent } from 'react';

const style = require('./TwoButtonDialog.scss');

export interface TwoButtonDialogProps
{
    ok: () => void;
    cancel: () => void;
    title?: string;
    
    okTitle: string;
    cancelTitle?: string;

    disabled?: boolean; // obsolete
    errorMessage?: string;

    okDisabled?: boolean;
    cancelDisabled?: boolean;
}
type Props = TwoButtonDialogProps & { children?: React.ReactNode };

export class TwoButtonDialog extends React.Component<Props, any>
{
    render()
    {
        const { title, ok, cancel,
            okTitle, cancelTitle,
            errorMessage,
            disabled = false, okDisabled = false, cancelDisabled = false,
            children
        } = this.props;
        const okClasses = classnames("btn btn-success", { disabled: disabled || okDisabled });
        const cancelClasses = classnames("btn btn-default", { disabled: disabled || cancelDisabled });
        return (
            <div className={style.TwoButtonDialog} onKeyDown={this.onKeyDown}>
                { title && <h3 className="text-center">{title}</h3> }
                {children}
                <div className={classnames(style.ButtomToolbar, 'has-error')}>
                    <div className={classnames(style.Info, "control-label")}>{errorMessage}</div>
                    {
                        cancelTitle && <button onClick={disabled || cancelDisabled ? null : cancel} className={cancelClasses} autoFocus>{cancelTitle}</button>
                    }
                    <button onClick={disabled || okDisabled ? null : ok} className={okClasses}>{okTitle}</button>
                </div>
            </div>
        );
    }

    onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        const { disabled, okDisabled, cancelDisabled, ok, cancel } = this.props;
        (e.keyCode === 13) && !disabled && !okDisabled && ok && ok();
        (e.keyCode === 27) && !disabled && !cancelDisabled && cancel && cancel();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Dialogs/TwoButtonDialog/TwoButtonDialog.tsx